var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { BASE_URL } from '../util/Url';
import Api from './Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptClientId } from '../util/encrypt';
function getOnboardingToken(params, token) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/token-history-onboarding-sdk/").concat(params.clientId);
                    if (token) {
                        url += "?token=" + token;
                    }
                    return [4 /*yield*/, Api.post(url)];
                case 1:
                    response = _a.sent();
                    if (response.status === 201) {
                        if (response.data.status === "CANCELED") {
                            throw Error('Esse token já foi cancelado por não ter sido utilizado. Favor gerar outro');
                        }
                        else if (response.data.status === "APPROVED" || response.data.status === "REFUSED") {
                            throw Error('Esse token já foi utilizado! Favor gerar outro.');
                        }
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha na obtenção do token do onboarding.');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function searchByToken(tokenOnboarding, clientId) {
    return __awaiter(this, void 0, void 0, function () {
        var encryptedClientId, url, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    encryptedClientId = encryptClientId(clientId);
                    url = "".concat(BASE_URL, "/onboarding/token-search/").concat(tokenOnboarding);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.get(url, { headers: { 'Validation-Token': encryptedClientId } })];
                case 2:
                    response = _a.sent();
                    if (response.status == 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha na busca de onboarding a partir do token.');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    throw Error('Falha na busca de onboarding a partir do token.');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getFirstStep(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, _a, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat(BASE_URL, "/product-params-first-step-onboarding/").concat(params.clientId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!params.tokenOnboarding) return [3 /*break*/, 3];
                    return [4 /*yield*/, Api.get(url, { params: { tokenOnboarding: params.tokenOnboarding } })];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, Api.get(url)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    response = _a;
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao obter primeira step');
                    }
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _b.sent();
                    throw Error('Falha ao obter primeira step');
                case 7: return [2 /*return*/];
            }
        });
    });
}
function saveStep(params, headers) {
    var _a, _b;
    if (headers === void 0) { headers = null; }
    return __awaiter(this, void 0, void 0, function () {
        var url, config, response, e_3, data, message;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = "".concat(BASE_URL, "/history-onboarding-step/").concat(params.tokenOnboarding);
                    config = {
                        headers: headers,
                        timeout: 29000
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.put(url, params, config)];
                case 2:
                    response = _c.sent();
                    if (response.status === 200 || response.status === 201) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao salvar os dados');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _c.sent();
                    data = (_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.data) !== null && _a !== void 0 ? _a : (_b = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _b === void 0 ? void 0 : _b.data;
                    message = (data === null || data === void 0 ? void 0 : data.title) || (data === null || data === void 0 ? void 0 : data.message) || (e_3 === null || e_3 === void 0 ? void 0 : e_3.message) || 'Falha ao salvar os dados';
                    if (data === null || data === void 0 ? void 0 : data.title) {
                        toast.error(data.title, {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                    throw Error(message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
function serviceField(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, config, response, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/service-field");
                    config = {
                        timeout: 10000
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.post(url, params, config)];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao chamar serviço do campo');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_4 = _a.sent();
                    if (e_4.data && e_4.data.title) {
                        toast.error(e_4.data.title, {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                    throw Error('Falha desconhecida ao chamar serviço do campo');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function stepSearch(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, config, response, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/onboarding/step-search");
                    config = {
                        timeout: 29000
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.post(url, params, config)];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao chamar serviço do campo');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_5 = _a.sent();
                    throw Error('Falha desconhecida ao chamar serviço do campo');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getStepResult(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/onboarding/").concat(params.tokenOnboarding, "/step-result");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.get(url, { signal: params.signal })];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    throw Error('Falha ao buscar resultados do onboarding');
                case 3:
                    e_6 = _a.sent();
                    throw Error('Falha ao buscar resultados do onboarding');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function createFaceLivenessSession() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/rekognition/create-face-liveness-session");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.get(url)];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao criar sessao do liveness');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_7 = _a.sent();
                    throw Error('Falha ao criar sessao do liveness');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getFaceLivenessSessionResult(sessionId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(BASE_URL, "/rekognition/result-face-liveness/").concat(sessionId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Api.get(url)];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw Error('Falha ao buscar resultado do liveness');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_8 = _a.sent();
                    throw Error('Falha ao buscar resultado do liveness');
                case 4: return [2 /*return*/];
            }
        });
    });
}
function checkIfImageIsValid(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get(url)];
                case 1:
                    response = _a.sent();
                    if (response.status === 200) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export default {
    getOnboardingToken: getOnboardingToken,
    getFirstStep: getFirstStep,
    saveStep: saveStep,
    serviceField: serviceField,
    stepSearch: stepSearch,
    createFaceLivenessSession: createFaceLivenessSession,
    getFaceLivenessSessionResult: getFaceLivenessSessionResult,
    checkIfImageIsValid: checkIfImageIsValid,
    searchByToken: searchByToken,
    getStepResult: getStepResult,
};
